import React from 'react';
import zh from '../../locales/zh-Hans.json';
import en from '../../locales/en-US.json';
import urlparser from 'urlparser';
import PCOpenTrialSuccess from '../../components/PCInputEmailTrial/PCOpenTrialSuccess';
import PCOpenPhoneTrialSuccess from '../../components/PCInputPhoneTrial/PCOpenPhoneTrialSuccess';
import ReactGA from 'react-ga';
import { Button } from 'antd';
import './index.scss'
import moment from 'moment';
import PCInputEmailTrial from '../../components/PCInputEmailTrial/PCInputEmailTrial';
import PCInputPhoneTrail from '../../components/PCInputPhoneTrial/PCInputPhoneTrial';

export interface IPCProps {
  logo: string,
  inviterId: string;
  trailId: string;
  qrcode:string;
  activityTime:any;
  privilegesDays:any;
  description:any;
  userRegisterType:any;
  state:any;
}

interface IState {
  errMsg: string;
  showErr: boolean;
  email: string;
  lang: string;
  showDialog: boolean;
  message: any;
  jwt: string;
  time: string;
  custom: any;
  title: string;
  disabled: boolean;
  isWeChat: string;
  buttonUrl: string;
  logo: string;
  inviterId: string;
  trailId: string;
  showVip: string;
  inputEmail: boolean;
  openSuccess: boolean;
  qrcode:string;
  activityTime:any;
  description:any;
  privilegesDays:any;
  userRegisterType:any;
  state:any;
}

class NewTrialPCPage extends React.Component<IPCProps, IState> {
  public readonly state: Readonly<IState> = {
    errMsg: '',
    showErr: false,
    email: '',
    lang: 'zh-Hans',
    showDialog: false,
    message: {
      'zh-Hans': zh,
      'en-US': en
    },
    jwt: '',
    time: '',
    custom: '',
    title: '',
    disabled: false,
    isWeChat: '',
    buttonUrl: '',
    logo: '',
    inviterId: '',
    trailId: '',
    showVip: 'personal',
    inputEmail: false,
    openSuccess: false,
    qrcode:'',
    activityTime:{},
    description:'',
    privilegesDays:'',
    userRegisterType:'',
    state:''
  };

  UNSAFE_componentWillMount() {
    let url = urlparser.parse(window.location.href);
    let path = url.path.base;
    if (path.split('/')[1] === 'en') {
      this.setState({ lang: 'en-US' });
    }
  }

  componentDidMount() {
    this.setState(
      {
        trailId: this.props.trailId,
        logo: this.props.logo,
        inviterId: this.props.inviterId,
        qrcode:this.props.qrcode,
        activityTime:this.props.activityTime,
        description:this.props.description,
        privilegesDays:this.props.privilegesDays,
        userRegisterType:this.props.userRegisterType,
        state:this.props.state
      });
  }

  render() {
    const { showVip, inputEmail, openSuccess, trailId, inviterId, time, logo,qrcode,description,activityTime,privilegesDays,userRegisterType,state } = this.state;
    return (
      <div className='pc-trial'>
        <div className='pc-trial-content-one-wrap'>
        <div className='pc-trial-content-one-box-wrap'>
        <div className='pc-trial-content-one-box'>
        <div className='pc-trial-content-one'>
            <div className='pc-trial-content-logo'>
              <img src={require('../../assets/new-trial/mobile-logo.svg')} alt=""/>
              {
                logo ? <img style={{margin:'0 16px'}} src={require('../../assets/invite-sf/with.svg')} alt=""/> : null
              }
              {
                logo ? <img src={logo} style={{ width: '106px', height: '30px' }} alt=""/> : null
              }
            </div>
            <div className='pc-trial-content-bottom'>
          <div className='pc-trial-content-left-first'>
            
            {
              description? <div className='pc-trial-content-left-item-two'>
                {description}
              </div>:null
            }
            <div className='pc-trial-content-left-item-one'>
              为你节约 90% 的 PPT 制作时间
            </div>
            {
              activityTime.startAt&&activityTime.endAt?<div className={'pc-trial-content-left-item-time'}>
                {moment(activityTime.startAt*1000).format('YYYY.MM.DD')} - {moment(activityTime.endAt*1000).format('YYYY.MM.DD')}
              </div>:null
            }
            <div className='pc-trial-content-left-item-four'>
              <div className='pc-trial-content-left-four-button' onClick={()=>window.open('https://www.islide.cc/download')}><img
                src={require('../../assets/new-trial/windows_button.svg')}  alt=""/>
              </div>
              <div className='pc-trial-content-left-four-button' onClick={()=>window.open('https://www.islide.cc/download')}><img
                src={require('../../assets/new-trial/mac_button.svg')} alt=""/>
              </div>
            </div>
          </div>
          <div className='pc-trial-content-right-first'>
            <img src={require('../../assets/new-trial/head_pic.svg')} alt=""/>
          </div>
          </div>
        </div>
        </div>
        </div>
        </div>
        <div className='pc-trial-content-two'>
        <img src={require('../../assets/new-trial/islide-intro.svg')}/>
        </div>
        <div className='pc-trial-content-three'>
          <img src={require('../../assets/new-trial/right-intro.svg')}/>
        </div>
        <div className='pc-trial-content-four'>
          <div className='pc-trial-content-left-four'>
            <div className='pc-trial-content-four-head'>领取方式</div>
            <div className='pc-trial-content-four-intro'>
              <p>点击网站底部「免费领取」按钮，填写{userRegisterType==='phone'?'手机':'邮箱'}注册，领取 iSlide 个人 {privilegesDays} 天会员体验；</p>
              <p>查阅「会员开通{userRegisterType==='phone'?'短信':'邮件'}」，获取账号与密码；</p>
              <p>使用「会员开通{userRegisterType==='phone'?'短信':'邮件'}」中的账号密码登录，即可获得相应会员权益。</p>
            </div>
          </div>
          <img src={require('../../assets/new-trial/bottom_pic.svg')}/>
          {/* {
            qrcode?<div className='pc-trial-content-right-four'>
              <img src={require('../../assets/new-trial/rightThree.png')} alt=""/>
              <p>关注 iSlide 领取更多福利</p>
            </div>:null
          } */}
        </div>
        <div className='pc-trial-content-bottom-box'>
        <div className='pc-trial-content-bottom'>
          <div>
            <p className='pc-trial-content-bottom-title'>{privilegesDays} 天个人会员体验 <img src={require('../../assets/new-trial/vip.svg')} alt="" /></p>
          <span className='pc-trial-content-bottom-text'>你和 PPT 高手之间，就只差一个 iSlide</span>
          </div>
          <Button className='pc-trial-content-bottom-right' type={'primary'}
                  onClick={() => this.setState({ inputEmail: true })}>免费领取</Button>
        </div>
        </div>
        {
          qrcode?<div className='pc-trial-right-fixed'>
          <div className='pc-tiral-right-fixed-item'>
            <img src={require('../../assets/new-trial/mini.svg')} alt="" />
            <img className='pc-tiral-right-fixed-item-hover' src={require('../../assets/new-trial/mini_hover.svg')} alt="" />
          </div>
          <div className='pc-tiral-right-fixed-item'>
          <img src={require('../../assets/new-trial/wechat.svg')} alt="" />
          <img className='pc-tiral-right-fixed-item-hover' src={require('../../assets/new-trial/wechat_hover.svg')} alt="" />
          </div>
        </div>:null
        }        
        {
          userRegisterType==='phone'?<PCInputPhoneTrail visible={inputEmail} onClose={(e: any, time?: any) => {
            this.setState({ inputEmail: false });
            if (e === true) {
              ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/email/success`);
              this.setState({ openSuccess: true, time: time });
            }
          }} trailId={trailId} inviterId={inviterId} state={state}/>:<PCInputEmailTrial visible={inputEmail} onClose={(e: any, time?: any) => {
            this.setState({ inputEmail: false });
            if (e === true) {
              ReactGA.pageview(window.location.pathname+`/${privilegesDays}days/phone/success`);
              this.setState({ openSuccess: true, time: time });
            }
          }} trailId={trailId} inviterId={inviterId} state={state}/>
        }
        {
          userRegisterType==='phone'?<PCOpenPhoneTrialSuccess visible={openSuccess} time={time} onClose={() => this.setState({ openSuccess: false })}/>:<PCOpenTrialSuccess visible={openSuccess} time={time} onClose={() => this.setState({ openSuccess: false })}/>
        }
      </div>
    );
  }
}

export default NewTrialPCPage;
